import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertBody, AlertTitle, Avatar, Box, ChatAltSolid, Flex, FormControl, FormLabel, Stack, Text, Textarea } from '@bonusly/design-system';

interface FeedbackFormProps {
	recipient: {
		id: string;
		name: string;
		imageUrl: string;
	};
	templateQuestions: Array<{ question: string; placeholder: string }>;
	templateAnswers: string[];
	handleAnswerChange: (index: number) => (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({ recipient, templateQuestions, templateAnswers, handleAnswerChange }) => {
	const { t } = useTranslation('feedback');
	return (
		<Stack spacing={4}>
			<Alert size="sm" backgroundColor="purpleAlpha.100">
				<AlertBody>
					<Flex alignItems="center" gap={2}>
						<ChatAltSolid color="purple.500" />
						<AlertTitle>{t('feedback.give_modal.description')}</AlertTitle>
					</Flex>
				</AlertBody>
			</Alert>
			<Flex justifyContent="space-between" alignItems="center">
				<FormLabel>{t('feedback.give_modal.recipient_label')}</FormLabel>
				<Box backgroundColor={'purpleAlpha.100'} py={2} px={3} borderRadius="sm">
					<Flex alignItems="center" columnGap={2}>
						<Avatar
							name={recipient.name}
							src={recipient.imageUrl}
							alt={t('feedback.give_modal.profile_picture_alt', {
								userName: recipient.name,
							})}
						/>
						<Text fontSize="sm">{recipient.name}</Text>
					</Flex>
				</Box>
			</Flex>
			{templateQuestions.map((template, index) => (
				<FormControl key={index}>
					<Flex justifyContent="space-between" alignItems="flex-start">
						<FormLabel maxW={'40%'}>{template.question}</FormLabel>
						<Textarea
							fontSize="lg"
							width="60%"
							_placeholder={{ color: 'gray.400', fontStyle: 'italic' }}
							placeholder={template.placeholder}
							value={templateAnswers[index]}
							onChange={handleAnswerChange(index)}
						/>
					</Flex>
				</FormControl>
			))}
		</Stack>
	);
};

export default FeedbackForm;
